import { currentBillingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentBillingAddress";
import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import { quickOrderStyles } from "@insite/content-library/Widgets/Basic/QuickOrder";
import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { myAccountViewStyles } from "@insite/content-library/Widgets/MyAccount/MyAccountView";
import { searchFormStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// MyAccountView
myAccountViewStyles.quickLinksGridItem = {
    width: [12, 12, 12, 3, 3],
};

myAccountViewStyles.mainSectionGridItem = {
    width: [12, 12, 12, 9, 9],
};

// Quick Order
quickOrderStyles.titleText = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

quickOrderStyles.container = {
    gap: 15,
    css: css`
        background-color: ${getColor("common.accent")};
        border: 1px solid ${getColor("common.border")};
        padding: 10px;
    `,
};

quickOrderStyles.linksGridItem = {
    width: [12, 7, 7, 7, 7],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 7.5px;
                `,
                css`
                    justify-content: flex-end;
                    padding: 7.5px;
                `,
                css`
                    justify-content: flex-end;
                    padding: 7.5px;
                `,
                css`
                    justify-content: flex-end;
                    padding: 7.5px;
                `,
                css`
                    justify-content: flex-end;
                    padding: 7.5px;
                `,
            ])}
    `,
};

quickOrderStyles.productSelector = {
    container: {
        gap: 30,
        css: css`
            border-left: 1px solid ${getColor("common.border")};
            border-right: 1px solid ${getColor("common.border")};
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 10px;
            margin-bottom: 30px;
        `,
    },
    searchGridItem: { width: [12, 12, 5, 5, 6] },
    qtyGridItem: { width: [3, 3, 2, 2, 2] },
    unitOfMeasureGridItem: { width: [9, 9, 2, 2, 2] },
    buttonGridItem: {
        width: [12, 12, 3, 3, 2],
        css: css`
            justify-content: flex-end;
        `,
    },
    selectButton: {
        css: css`
            width: 100%;
            align-self: flex-end;
        `,
    },
    clearIcon: {
        css: css`
            position: absolute;
            right: 50px;
            top: 55px;
            cursor: pointer;
        `,
    },
};

// Invoice History Filter
filterStyles.container = {
    css: css`
        background-color: ${getColor("common.accent")};
        border: 1px solid ${getColor("common.border")};
        padding: 10px;
        margin-bottom: 15px;
    `,
};

// Saved Order List Filter
savedOrderListFilterStyles.container = {
    css: css`
        background-color: ${getColor("common.accent")};
        border: 1px solid ${getColor("common.border")};
        margin-bottom: 15px;
        padding-bottom: 10px;
        padding-top: 10px;
    `,
};

savedOrderListFilterStyles.heading = {
    css: css`
        padding-left: 10px;
        padding-right: 10px;
    `,
    variant: "h5",
};

savedOrderListFilterStyles.orderTotalGridItem = {
    css: css`
        padding: 15px 10px 15px 25px;
    `,
    width: [12, 12, 6, 6, 6],
};

savedOrderListFilterStyles.datesGridItem = {
    css: css`
        padding: 15px;
    `,
    width: [12, 12, 6, 4, 4],
};

// Order History Search Form
searchFormStyles.wrapper = {
    css: css`
        background-color: ${getColor("common.accent")};
        border: 1px solid ${getColor("common.border")};
        padding-bottom: 10px;
        padding-top: 10px;
        margin-bottom: 15px;
    `,
};

searchFormStyles.headingText = {
    css: css`
        padding-left: 10px;
        padding-right: 10px;
    `,
    variant: "h5",
};

// Current Billing Address
currentBillingAddressStyles.gridContainer = {
    css: css`
        background-color: ${getColor("common.accent")};
        border: 1px solid ${getColor("common.border")};
        padding: 10px;
        margin-bottom: 15px;
    `,
};

// Current Shipping Address
currentShippingAddressStyles.gridContainer = {
    css: css`
        background-color: ${getColor("common.accent")};
        border: 1px solid ${getColor("common.border")};
        padding: 10px;
        margin-bottom: 15px;
    `,
};

// SavedPaymentsDefaultCard
defaultCardStyles.mainWrapper = {
    css: css`
        background-color: ${getColor("common.accent")};
        border: 1px solid ${getColor("common.border")};
        padding: 20px;
    `,    
}